import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { fetchCategories } from 'entities/Category';
import { getSelectedPropertyCatalogId } from 'entities/Property/model/selectors/PropertySelectors';
import { ReviewOrderButton, ReviewOrderFooter } from 'features/AddItemsToOrder';
import { addItemsToOrderIsLoading } from 'features/AddItemsToOrder/model/selectors/addItemsToOrderSelectors';
import { getSearchCatalogItemIsActive } from 'features/SearchCatalogItems/model/selectors/searchCatalogItemsSelectors';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';
import {
    PropertyCatalog,
    PropertyCatalogItemsMoveTo,
} from 'widgets/PropertyCatalog';
import { SearchCatalogItems } from 'widgets/SearchCatalogItems';

export const OrderAddItemPageCatalog = () => {
    const location = useLocation();
    const dispatch = useAppDispatch();

    const isLoadingUpdateOrder = useSelector(addItemsToOrderIsLoading);
    const isActive = useSelector(getSearchCatalogItemIsActive);
    const selectedPropertyCatalogId = useSelector(getSelectedPropertyCatalogId);

    const catalogId =
        location.state?.selectedPropertyCatalogId || selectedPropertyCatalogId;

    const orderType = location.state?.orderType;

    useEffect(() => {
        if (catalogId) {
            dispatch(fetchCategories(catalogId));
        }
    }, [catalogId, dispatch]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <SearchCatalogItems
                catalogId={catalogId}
                moveTo={PropertyCatalogItemsMoveTo.ORDER}
                expandable
                hideField
            />

            {!isActive && (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            borderRadius: '12px 12px 0 0',
                            overflow: 'hidden',
                            height: 'calc(100vh - 466px)',
                        }}
                    >
                        <PropertyCatalog
                            isEditing
                            moveTo={PropertyCatalogItemsMoveTo.ORDER}
                        />
                    </Box>

                    <ReviewOrderFooter>
                        <ReviewOrderButton
                            isLoadingUpdateOrder={isLoadingUpdateOrder}
                            orderType={orderType}
                        />
                    </ReviewOrderFooter>
                </>
            )}
        </Box>
    );
};
